import React from 'react';
import Header from '../components/Header';
import Header2 from '../components/Header2';
import Footer from '../components/Footer';


const Team = () => {
    return (
        <>
            <Header page="ressources" />
            <Header2 title="ressources" subtitle="ressources" />
            <Footer />
        </>

    );
}


export default Team;